import { MockError, MockSuccess, waitRand } from '@sift/resift/redux/MockDataService';
// import delay from 'delay';

export const mockDataServiceHandlers = {
  USER_FETCH: async action => {
    // waitRand is just a random delay between 1234ms and 1934ms
    // this simulates a load time from the API so you can test
    // load states
    await waitRand();

    // testing logic to be able to test success or error
    if (action.payload.id === 'abc123') {
      return new MockSuccess({
        id: action.payload.id,
        created: new Date(),
        displayName: 'Eric Harrison',
      });
    } else {
      return new MockError(407, `User not found: ${action.payload.id}`);
    }
  },
};

export default mockDataServiceHandlers;
